import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import AiAgentIcon from "@atlaskit/icon/core/ai-agent";
import EditIcon from "@atlaskit/icon/core/edit";
import LobbyBellIcon from "@atlaskit/icon/core/lobby-bell";
import PageIcon from "@atlaskit/icon/core/page";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";

import { tabbedHeroSectionShareKnowledgeMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

import { ContentTypeImage } from "./content-type-image.tsx";

import type { TabProps, TabType } from "./tab-type.tsx";

type KnowledgeContentTypeProps = TabProps;

export const KnowledgeContentType: TabType =
    ({}: KnowledgeContentTypeProps) => {
        const intl = useIntl();
        const { createAnalyticsEvent } = useAnalyticsEvents();
        const { user } = useUserContext();

        return (
            <ContentTypeImage
                imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/56m2ndu02rfu3qa17o7yl2i13t0628s0.webp"
                imageAlt="A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
                title={intl.formatMessage(
                    tabbedHeroSectionShareKnowledgeMessages.contentTitle
                )}
                description={intl.formatMessage(
                    tabbedHeroSectionShareKnowledgeMessages.contentDescription
                )}
                hideSeparator={true}
                iconCollection={[
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionShareKnowledgeMessages.contentFeaturePoint1
                        ),
                        icon: <LobbyBellIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionShareKnowledgeMessages.contentFeaturePoint2
                        ),
                        icon: <PageIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionShareKnowledgeMessages.contentFeaturePoint3
                        ),
                        icon: <EditIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionShareKnowledgeMessages.contentFeaturePoint4
                        ),
                        icon: <AiAgentIcon label="" />
                    }
                ]}
                cta={
                    // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                    <Link
                        href={"/software/jira/service-management"}
                        text={intl.formatMessage(
                            tabbedHeroSectionShareKnowledgeMessages.contentCta
                        )}
                        type={"primary"}
                        dataEventProps={{
                            "data-product-key": "jiraServiceManagement",
                            "data-event-component": "linkButton",
                            "data-event-container": "tabsMenu",
                            "data-event": "clicked",
                            "data-label": "try-it-out",
                            "data-label-english":
                                "Explore Jira Service Management",
                            "data-track-event":
                                "jsm-pt.content-types.share-knowledge.cta"
                        }}
                        onClick={() => {
                            createAnalyticsEvent({
                                eventName: "jsm-crossflow-tab-cta-clicked",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "linkButton",
                                actionSubjectId: "jsmCrossFlowHeroSection",
                                attributes: {
                                    reactComponent: "KnowledgeContentType",
                                    tab: "share-knowledge",
                                    userTeamType:
                                        user["extended_profile"]?.team_type
                                }
                            }).fire();
                        }}
                    />
                }
                reverseLayout
            />
        );
    };
